const SESSION_KEY = "ai-session-id";

const readSession = () => {
	try {
		return JSON.parse(
			localStorage.getItem(SESSION_KEY) || '{"sessionId":"","qty":0}'
		);
	} catch {
		return { sessionId: "", qty: 0 };
	}
};

const writeSession = (session) => {
	localStorage.setItem(SESSION_KEY, JSON.stringify(session));
};

export default (config = {}) => ({
	config,
	modalOpen: false,
	query: "",
	messages: [],
	loading: false,
	showReset: false,
	tags: [
		"A custom built split tank for fuel and hydraulics",
		"A replacement cap 4-nv-l-alum-8-tpi",
		"Part number 11-04821-052T100UP",
		"Custom tanks",
		'A 134 gallon 26 diameter 58" long peterbilt',
		'A 61 gallon 26 diameter 31" long mack style',
	],

	init() {
		if (Number(readSession().qty) >= 2) this.showReset = true;
	},

	openModal() {
		if (!this.messages.length) {
			this.messages.push({
				role: "bot",
				text: this.config.welcomeMsg || "Hello, how can I help you?",
			});
		}
		this.modalOpen = true;
		this.scrollSoon();
	},
	closeModal() {
		this.modalOpen = false;
	},
	toggleModal() {
		this.modalOpen ? this.closeModal() : this.openModal();
	},

	pickTag(tag) {
		this.query = tag;
		this.$refs.queryInput?.focus();
	},

	submit() {
		const text = this.query.trim();
		if (!text) return;
		this.resetSession({ preserveQuery: true });
		this.openModal();
		this.send(text);
		this.query = "";
	},

	modalSubmit() {
		const text = this.query.trim();
		if (!text || this.loading) return;
		this.send(text);
		this.query = "";
	},

	resetSession({ preserveQuery = false } = {}) {
		writeSession({ sessionId: "", qty: 0 });
		this.messages = [];
		this.showReset = false;
		if (!preserveQuery) this.query = "";
	},

	startNewChat() {
		this.resetSession();
		this.messages.push({
			role: "bot",
			text: this.config.welcomeMsg || "Hello, how can I help you?",
		});
		this.scrollSoon();
	},

	scrollSoon() {
		this.$nextTick(() => {
			const el = this.$refs.messages;
			if (el) el.scrollTop = el.scrollHeight;
		});
	},

	buildBotMessage(data) {
		const msg = { role: "bot" };
		if (data.responseAnswer) {
			msg.html = data.responseAnswer.replace(/\n/g, "<br/>");
		} else {
			msg.text = "Sorry, I am not able to answer your question";
		}
		return msg;
	},

	async send(text) {
		this.messages.push({ role: "user", text });
		this.loading = true;
		this.scrollSoon();

		const session = readSession();
		const qty = Number(session.qty);

		try {
			const response = await fetch(this.config.url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"X-PubApi-Key": this.config.publicKey,
				},
				body: JSON.stringify({
					query: text,
					session: session.sessionId || "",
				}),
			});
			const data = await response.json();

			if (data.error) {
				this.messages.push({ role: "error", text: this.config.errorMsg });
			} else {
				writeSession({
					sessionId: data.session || "",
					qty: qty <= 2 ? qty + 1 : 0,
				});
				if (qty >= 2) this.showReset = true;
				this.messages.push(this.buildBotMessage(data));
			}
		} catch {
			this.messages.push({ role: "error", text: this.config.errorMsg });
		} finally {
			this.loading = false;
			this.scrollSoon();
			this.$refs.modalInput?.focus();
		}
	},
});
